import Meta from '@/components/common/Meta'

import ShipToStoragePage from '@/v2/components/pages/landing-pages/ship-to-storage-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/landing-pages/ship-to-storage-page'

interface ShipToStoragePageProps {}

const Page: React.FC<ShipToStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={LANDING_PAGES_META_CONTENTS.ship_to_storage.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''}
        keywords={
          LANDING_PAGES_META_CONTENTS.ship_to_storage?.keywords ?? LANDING_PAGES_META_CONTENTS.default?.keywords ?? ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.ship_to_storage?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <ShipToStoragePage />
    </>
  )
}

export default Page
